import guardUtils from '@/portal/guards/guard-utils';
import store from '@/store';

const businessSelected = {
  check: async () => {
    const selectedBusiness = _.get(store.state, 'workerOnBoarding.selectedBusiness');
    return !!selectedBusiness;
  },
  redirectOnFail: {
    name: 'workerOnBoardingBusinessSearch',
  },
};

const existingBusinessSelected = {
  check: async () => {
    const selectedBusinessUuid = _.get(store.state, 'workerOnBoarding.selectedBusiness.uuid');
    return !!selectedBusinessUuid;
  },
  redirectOnFail: {
    name: 'workerOnBoardingBusinessSearch',
  },
};

const hasOneTimePass = {
  check: async (to) => {
    const oneTimePass = await guardUtils.fetchOneTimePassUsingQueryParams(to);
    return !!oneTimePass;
  },
  redirectOnFail: {
    name: 'oneTimePassNotFound',
  },
};

const workerCreated = {
  check: async () => {
    const workerExists = !!(await guardUtils.fetchWorkerUuid());
    if (!workerExists) {
      await guardUtils.createWorkerForUser();
    }
    return true;
  },
};

const workerNotOnBoarded = {
  check: async () => {
    const onBoarded = await guardUtils.hasWorkerOnBoarded();
    return !onBoarded;
  },
  redirectOnFail: {
    name: 'oneTimePassWelcome',
  },
};

export default {
  businessSelected,
  existingBusinessSelected,
  hasOneTimePass,
  workerCreated,
  workerNotOnBoarded,
};
